// Not in final designs (from previous designs)

import * as React from 'react';
import './payment-modal.scss';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import TextInput from '../../../common/text-input/text-input';
import Button from '../../../common/button/button';

interface Props {
  onClose: Function;
}

interface PaymentInfo {
  dob: string;
  cardNumber: string;
  validity: string;
  password: string;
  automaticPayment: boolean;
}

const PaymentModal: React.FC<Props> = ({ onClose }) => {
  const [paymentInfo, setPaymentInfo] = React.useState<PaymentInfo>({
    dob: '',
    cardNumber: '',
    validity: '',
    password: '',
    automaticPayment: false,
  });

  const onCloseModal = () => {
    onClose(false);
  };

  const inputData = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPaymentInfo((values) => ({ ...values, [name]: value }));
  };

  const handleRegister = () => {
    // Send payment info to the backend
  };

  const enableAutomaticPayement = () => {
    setPaymentInfo((values) => ({ ...values, automaticPayment: !paymentInfo.automaticPayment }));
  };

  return (
    <div className="payment-modal">
      <div className="payment-modal-content">
        <div className="modal-action">
          <div className="modal-action__close" onClick={onCloseModal}>
            <Close />
          </div>
        </div>
        <div className="modal-header font">결제 정보</div>
        <div className="modal-subheader font">카드 정보를 등록하면 자동 결제 진행돼요</div>
        <form>
          <div className="payment-modal-input">
            <div className="payment-modal-input__input-box">
              <TextInput
                inputData={inputData}
                value={paymentInfo.dob}
                inputName="dob"
                label="생년월일"
                placeholder="YYMMDD"
              />
            </div>
            <div className="payment-modal-input__input-box">
              <TextInput
                inputData={inputData}
                value={paymentInfo.cardNumber}
                inputName="cardNumber"
                label="카드번호"
                placeholder="카드 번호 입력"
              />
            </div>

            <div className="payment-modal-info">
              <div className="payment-modal-info__validity">
                <TextInput
                  inputData={inputData}
                  value={paymentInfo.validity}
                  inputName="validity"
                  label="생년월일"
                  placeholder="MM/YY"
                />
              </div>
              <div className="payment-modal-info__password">
                <TextInput
                  inputData={inputData}
                  value={paymentInfo.password}
                  inputName="password"
                  label="생년월일"
                  placeholder="비밀번호 앞 두자리"
                />
              </div>
            </div>

            <div className="payment-modal-register">
              <Button label="등록" type="type2" action={handleRegister} />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default PaymentModal;
